/* GYNGRAF — Lista de cotización (varios productos en un solo pedido de cotización) */
(function () {
  if (window.__gpCotiz) return;
  window.__gpCotiz = true;
  var KEY = 'gp_cotizacion_v1';
  var cfg = window.GP_COTIZ || {};
  var WSP = (cfg.whatsapp || '51916493017').replace(/[^0-9]/g, '');
  var MIN = parseInt(cfg.minimo || 50, 10);

  function leer() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function guardar(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} pintar(); }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function agregar(item, cant) {
    var l = leer();
    var i = l.findIndex(function (x) { return x.url === item.url; });
    var n = parseInt(cant, 10); cant = n > 0 ? n : '';
    if (i > -1) l[i].cant = cant; else l.push({ titulo: item.titulo, url: item.url, img: item.img, sku: item.sku, cant: cant });
    guardar(l);
    aviso('Añadido a tu cotización: ' + item.titulo);
  }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var panel, lista, contador, flot;

  function pintarBotones() {
    var l = leer();
    document.querySelectorAll('[data-gp-add]').forEach(function (b) {
      var en = l.some(function (x) { return x.url === b.getAttribute('data-url'); });
      if (b.classList.contains('is-en-lista') !== en) b.classList.toggle('is-en-lista', en);
      var t = b.querySelector('[data-gp-add-txt]');
      var txt = en ? (b.getAttribute('data-txt-en') || 'En tu lista ✓') : (b.getAttribute('data-txt') || '+ Cotizar');
      if (t && t.textContent !== txt) t.textContent = txt;
    });
  }

  function pintar() {
    var l = leer();
    if (contador && contador.textContent !== String(l.length)) { contador.textContent = l.length; }
    if (flot) flot.classList.toggle('gp-cz-flot--on', l.length > 0);
    pintarBotones();
    if (!lista) return;
    if (!l.length) {
      lista.innerHTML = '<div class="gp-cz-vacio"><b>Tu lista está vacía</b><span>Pulsa “+ Cotizar” en los productos que te interesan y aquí los verás juntos.</span></div>';
    } else {
      lista.innerHTML = l.map(function (x, i) {
        return '<li class="gp-cz-item">' +
          (x.img ? '<img src="' + esc(x.img) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="gp-cz-ph"></span>') +
          '<div class="gp-cz-info"><a href="' + esc(x.url) + '">' + esc(x.titulo) + '</a>' +
          '<label class="gp-cz-cant">Cantidad <input type="number" min="1" step="1" inputmode="numeric" placeholder="Ej.: 12" value="' + (x.cant || '') + '" data-i="' + i + '"> unid.</label></div>' +
          '<button type="button" class="gp-cz-quitar" data-quitar="' + i + '" aria-label="Quitar ' + esc(x.titulo) + '">×</button></li>';
      }).join('');
    }
    var tot = l.reduce(function (a, x) { return a + (parseInt(x.cant, 10) || 0); }, 0);
    var t = $('[data-gp-cz-total]'); if (t) t.textContent = l.length ? (l.length + (l.length === 1 ? ' producto' : ' productos') + (tot ? ' · ' + tot.toLocaleString('es-PE') + ' unidades' : '')) : '';
    document.querySelectorAll('[data-gp-cz-enviar]').forEach(function (b) { b.disabled = !l.length; });
  }

  function aviso(txt) {
    var a = $('.gp-cz-toast');
    if (!a) { a = document.createElement('div'); a.className = 'gp-cz-toast'; a.setAttribute('role', 'status'); document.body.appendChild(a); }
    a.innerHTML = '<span>' + esc(txt) + '</span><button type="button" data-gp-cz-abrir>Ver lista</button>';
    a.classList.add('is-on');
    clearTimeout(a._t); a._t = setTimeout(function () { a.classList.remove('is-on'); }, 3500);
  }

  function abrir() { if (!panel) return; panel.hidden = false; requestAnimationFrame(function () { panel.classList.add('is-on'); }); document.documentElement.style.overflow = 'hidden'; var f = $('.gp-cz-cerrar', panel); if (f) f.focus(); }
  function cerrar() { if (!panel) return; panel.classList.remove('is-on'); document.documentElement.style.overflow = ''; setTimeout(function () { panel.hidden = true; }, 300); }

  function mensaje() {
    var l = leer();
    var d = {}; panel.querySelectorAll('[data-gp-cz-dato]').forEach(function (f) { d[f.name] = f.value.trim(); });
    var m = 'Hola GYNGRAF, quiero cotizar estos productos:\n\n';
    l.forEach(function (x, i) { m += (i + 1) + '. ' + x.titulo + (x.sku ? ' (Cód. ' + x.sku + ')' : '') + ' — ' + (x.cant ? x.cant + ' unid.' : 'cantidad por definir') + '\n'; });
    if (d.nombre) m += '\nNombre: ' + d.nombre;
    if (d.empresa) m += '\nEmpresa: ' + d.empresa;
    if (d.personalizacion) m += '\nPersonalización: ' + d.personalizacion;
    if (d.fecha) m += '\nFecha requerida: ' + d.fecha;
    if (d.notas) m += '\nComentarios: ' + d.notas;
    return m;
  }

  // Avisa a los píxeles (Eventos del cliente de Shopify) cuando alguien inicia contacto
  function evento(nombre, datos) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, datos || {}); } catch (e) {}
  }
  function enviarWsp() {
    evento('gp_whatsapp_click', { origen: 'lista-cotizacion', pagina: location.pathname });
    window.open('https://wa.me/' + WSP + '?text=' + encodeURIComponent(mensaje()), '_blank', 'noopener');
  }
  function enviarForm() {
    try { sessionStorage.setItem('gp_cz_msg', mensaje()); } catch (e) {}
    location.href = (cfg.form || '/pages/cotizacion') + '?lista=1';
  }

  // Rellena el formulario de cotización con la lista
  function rellenarFormulario() {
    if (location.search.indexOf('lista=1') === -1) return;
    var l = leer(); if (!l.length) return;
    var msg = ''; try { msg = sessionStorage.getItem('gp_cz_msg') || ''; } catch (e) {}
    var prod = document.querySelector('[data-gyn-producto], input[name="contact[Productos]"]');
    var cant = document.querySelector('input[name="contact[Cantidad]"]');
    var body = document.querySelector('form textarea[name="contact[body]"]');
    var tot = l.reduce(function (a, x) { return a + (parseInt(x.cant, 10) || 0); }, 0);
    if (prod) prod.value = l.map(function (x) { return x.titulo + (x.sku ? ' (' + x.sku + ')' : ''); }).join('; ').slice(0, 480);
    if (cant && tot) cant.value = tot + ' unidades en total';
    if (body && msg) body.value = msg;
  }

  // Clics en cualquier botón de WhatsApp de la tienda (no los de "compartir") y envío del formulario de cotización
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/"]');
    if (!a || a.href.indexOf('wa.me/?') !== -1) return;
    evento('gp_whatsapp_click', { origen: a.getAttribute('data-gp-origen') || (a.className || '').split(' ')[0] || 'enlace', pagina: location.pathname });
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.querySelector && f.querySelector('input[value="SOLICITUD DE COTIZACIÓN"]')) evento('gp_form_cotizacion', { pagina: location.pathname });
  }, true);

  function init() {
    panel = $('[data-gp-cz-panel]'); lista = panel && $('[data-gp-cz-lista]', panel);
    contador = $('[data-gp-cz-count]'); flot = $('.gp-cz-flot');
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gp-add]');
      if (b) {
        e.preventDefault(); e.stopPropagation();
        var q = b.getAttribute('data-qty-from'); var cant = q ? (document.querySelector(q) || {}).value : b.getAttribute('data-cant');
        agregar({ titulo: b.getAttribute('data-title'), url: b.getAttribute('data-url'), img: b.getAttribute('data-img'), sku: b.getAttribute('data-sku') }, cant);
        return;
      }
      if (e.target.closest('[data-gp-cz-abrir]')) { e.preventDefault(); abrir(); return; }
      if (e.target.closest('[data-gp-cz-cerrar]')) { cerrar(); return; }
      var qx = e.target.closest('[data-quitar]');
      if (qx) { var l = leer(); l.splice(+qx.getAttribute('data-quitar'), 1); guardar(l); return; }
      if (e.target.closest('[data-gp-cz-wsp]')) { enviarWsp(); return; }
      if (e.target.closest('[data-gp-cz-form]')) { enviarForm(); return; }
      if (e.target.closest('[data-gp-cz-vaciar]')) { if (confirm('¿Vaciar tu lista de cotización?')) guardar([]); }
    }, true);
    document.addEventListener('change', function (e) {
      var i = e.target.getAttribute && e.target.getAttribute('data-i');
      if (i !== null && i !== undefined && e.target.closest('[data-gp-cz-lista]')) {
        var l = leer(); if (l[+i]) { var v = parseInt(e.target.value, 10); l[+i].cant = v > 0 ? v : ''; guardar(l); }
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel && !panel.hidden) cerrar(); });
    pintar();
    rellenarFormulario();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', pintar);
  // Las tarjetas que se cargan después (filtros, búsqueda) también se actualizan
  new MutationObserver(function (muts) {
    var hay = muts.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches && n.matches('[data-gp-add]') || n.querySelector && n.querySelector('[data-gp-add]')); }); });
    if (hay) { clearTimeout(window.__gpCzT); window.__gpCzT = setTimeout(pintarBotones, 150); }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
